import type { ViewRecordFieldChange } from '@salescore/client-redux'
import type { ViewQueryRecordNode } from '@salescore/core'
import { pipe } from 'effect'

import { generateNewRecordId } from '../../../state/nodeUtility'
import { type DeepReadonly, toMutable } from '../../types/DeepReadonly'
import type { NewRecordChange } from './addNewRecords'

// 非破壊的にルートレコードを追加する
export function addNewRootRecord(
  rootRecordNodes: DeepReadonly<ViewQueryRecordNode[]>,
  newRecordIds: DeepReadonly<string[]>,
  newRecordChange: DeepReadonly<NewRecordChange>,
): {
  processedRootRecordNodes: ViewQueryRecordNode[]
  processedNewRecordIds: string[]
  recordNode: ViewQueryRecordNode & { id: string }
  change: ViewRecordFieldChange | undefined
} {
  const { rowIndex, node } = newRecordChange

  // 新規レコードを生成
  const recordNode = generateNewRootRecord()

  const processedRootRecordNodes = pipe(rootRecordNodes.toSpliced(rowIndex, 0, recordNode), toMutable)
  const processedNewRecordIds = newRecordIds.toSpliced(rowIndex, 0, recordNode.id)

  // 子レコードがないので、メタ情報の更新は不要

  // 変更差分を生成
  const change: ViewRecordFieldChange | undefined =
    node.write === undefined
      ? undefined
      : {
          rootNodeId: recordNode.id,
          id: recordNode.id,
          streamName: node.write.streamName,
          fieldChanges: [],
          before: {},
          after: {},
        }

  return {
    processedRootRecordNodes,
    processedNewRecordIds,
    recordNode,
    change,
  }
}

// 非破壊的にルートレコードを生成する
export function generateNewRootRecord(): ViewQueryRecordNode & { id: string } {
  return {
    id: generateNewRecordId(),
    attributes: {},
    children: [],
    meta: {
      height: 1,
      innerRowIndexStart: 0,
      innerRowIndexEnd: 1,
    },
  }
}
